import { render } from "./DocumentSectionComponent.vue?vue&type=template&id=35fb5302"
import script from "./DocumentSectionComponent.vue?vue&type=script&lang=js"
export * from "./DocumentSectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__